import React from 'react';
import _ from 'lodash';

import { FormElement, FormList, FormListItem } from '../CommonFormComponents';
import AttachDocument from './AttachDocument';
import { DateInput } from '../DateInput';

import { wrapperValidExpirationDate } from '../../utilities/dateSelectorUtility';
import { messageUtility } from '../../utilities/messageUtility';

export const CompanyOtherIndustryLicenseForm = props => {
  const {
    validate,
    formEvents,
    attachmentEvens,
    formValues,
    warningMsg,
  } = props;
  const licenseDuplicatedMessage = _.get(
    validate,
    'messages.license_duplicate'
  );
  const renderIndustryName = () => {
    return (
      <FormElement
        validate={_.get(validate, 'messages.authorized_industry_names')}
      >
        <div className='form-list-container'>
          <div className='form-list-container--item'>
            <input
              type='text'
              name='authorized_industry_names'
              maxLength={40}
              value={formValues.authorized_industry_names}
              onChange={e =>
                formEvents.handleOnChange(
                  e.target.value,
                  'authorized_industry_names'
                )
              }
              onBlur={() =>
                formEvents.handleValidate('authorized_industry_names')
              }
            />
          </div>
        </div>
      </FormElement>
    );
  };
  const renderPermissionNumber = () => {
    return (
      <FormElement
        info={messageUtility.getMessage('I-000-146')}
        validate={_.get(validate, 'messages.permission_number_r')}
      >
        <div className='form-list-container'>
          <div className='form-list-container--item'>
            <span className='form-list-container--label'>第</span>
            <input
              type='text'
              name='permission_number_r'
              maxLength={20}
              value={formValues.permission_number_r}
              onChange={e =>
                formEvents.handleOnChange(e.target.value, 'permission_number_r')
              }
              onBlur={() => formEvents.handleValidate('permission_number_r')}
            />
            <span className='form-list-container--label'>号</span>
          </div>
        </div>
      </FormElement>
    );
  };

  const renderAttachment = () => {
    const { documentCodes } = props;
    return (
      <AttachDocument
        companyDocuments={formValues.company_documents}
        documentCodes={documentCodes}
        events={attachmentEvens}
        isFormListDefault
        indexId='CompanyOtherIndustryLicenseForm'
      />
    );
  };

  return (
    <div className='CompanyOtherIndustryLicenseForm'>
      <FormList>
        {licenseDuplicatedMessage && (
          <FormListItem className='form-list__element--common-error'>
            <div className='text--negative'>{licenseDuplicatedMessage}</div>
          </FormListItem>
        )}
        <FormListItem label='許可業種' required={true} safetyDocItem={true}>
          {renderIndustryName()}
        </FormListItem>
        <FormListItem
          label='許可番号 固有番号'
          required={true}
          safetyDocItem={true}
        >
          {renderPermissionNumber()}
        </FormListItem>
        <FormListItem
          label='許可（更新）年月日'
          required={true}
          safetyDocItem={true}
        >
          <DateInput
            dateString={formValues.license_update_date}
            message={_.get(validate, 'messages.license_update_date')}
            info='※その他許可を更新した最新の日付を入力してください。労務安全書類にはこの日付が出力されます。'
            jpDelimiterChar={true}
            onChangeValue={value =>
              formEvents.handleOnChange(value, 'license_update_date')
            }
            onBlur={() => formEvents.handleValidate('license_update_date')}
          />
        </FormListItem>
        <FormListItem label='有効期限年月日' safetyDocItem={true}>
          <DateInput
            dateString={formValues.license_limit_date}
            message={_.get(validate, 'messages.license_limit_date')}
            info='※有効期限がある場合のみ入力してください。'
            warning={
              wrapperValidExpirationDate(
                formValues.license_limit_date,
                '許可',
                true,
                _.get(validate, 'messages.license_limit_date'),
                '許可（更新）年月日、有効期限年月日、添付書類'
              ) || _.get(warningMsg, 'license_limit_date')
            }
            jpDelimiterChar={true}
            onChangeValue={value =>
              formEvents.handleOnChange(value, 'license_limit_date')
            }
            onBlur={() => formEvents.handleValidate('license_limit_date')}
          />
        </FormListItem>
        <FormListItem label='添付書類'>
          <FormElement
            warning={
              _.isEmpty(formValues.company_documents) &&
              '添付書類が添付されておりません。'
            }
          >
            {renderAttachment()}
          </FormElement>
        </FormListItem>
      </FormList>
    </div>
  );
};

export default CompanyOtherIndustryLicenseForm;



// WEBPACK FOOTER //
// ./src/components/forms/CompanyOtherIndustryLicenseForm.jsx